import { render, staticRenderFns } from "./Faqs-fr.vue?vue&type=template&id=3e372414&"
import script from "./Faqs-fr.vue?vue&type=script&lang=js&"
export * from "./Faqs-fr.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports